import { useMotionValueEvent, useScroll } from 'framer-motion';
import { useRef } from 'react';

export interface SectionSpacerTrackProps {
  readonly activeIndex: number;
  readonly onActiveSectionChange: (index: number) => void;
  readonly sectionCount: number;
}

export const handleScrollYProgressChange = ({
  activeIndex,
  latest,
  onActiveSectionChange,
  sectionCount,
}: SectionSpacerTrackProps & {
  latest: number;
}): void => {
  const currentSectionIndex = Math.min(
    Math.floor(latest * sectionCount),
    sectionCount - 1,
  );
  if (activeIndex !== currentSectionIndex) {
    onActiveSectionChange(currentSectionIndex);
  }
};

const SectionSpacerTrack = ({
  activeIndex,
  onActiveSectionChange,
  sectionCount,
}: SectionSpacerTrackProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end end'],
  });

  useMotionValueEvent(scrollYProgress, 'change', (latest): void => {
    handleScrollYProgressChange({
      activeIndex,
      latest,
      onActiveSectionChange,
      sectionCount,
    });
  });

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none hidden lg:js:block"
      data-cy="timeline_spacer_track"
      ref={ref}
      style={{ height: `${sectionCount * 100}vh` }}
    />
  );
};

export default SectionSpacerTrack;
